import { render, staticRenderFns } from "./BillMonthlyTrendChart.vue?vue&type=template&id=72a70a32&scoped=true"
import script from "./BillMonthlyTrendChart.vue?vue&type=script&lang=js"
export * from "./BillMonthlyTrendChart.vue?vue&type=script&lang=js"
import style0 from "./BillMonthlyTrendChart.vue?vue&type=style&index=0&id=72a70a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a70a32",
  null
  
)

export default component.exports